<template>
	<div>
		<TransitionRoot as="template" :show="show">
			<Dialog as="div" class="relative z-10" @close="$emit('close')">
				<div class="fixed inset-0" />
 
 
				<div class="fixed inset-0 overflow-hidden">
					<div class="absolute inset-0 overflow-hidden bg-[#0000014d]">
						<div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
							<TransitionChild
								as="template"
								enter="transform transition ease-in-out duration-300"
								enter-from="translate-x-full"
								enter-to="translate-x-0"
								leave="transform transition ease-in-out duration-300"
								leave-from="translate-x-0"
								leave-to="translate-x-full">
								<DialogPanel class="pointer-events-auto w-screen md:max-w-[660px]">
									<div class="flex h-full flex-col overflow-y-scroll bg-white md:rounded-l-lg shadow-xl">
										<div class="flex flex-col relative">
											<div
												class="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
												<p class="font-semibold text-sm">Addresses</p>
												<XMarkIcon
													class="h-6 w-6 stroke-2 cursor-pointer hover:text-primary-600 transition"
													@click="$emit('close')" />
											</div>
											<div class="px-4 pt-1.5 pb-4">
												<div class="flex justify-end">
													<a
														@click="
															router.push(
																`/patient/${patientId}/cases/${caseId}/patient-addresses/create`
															);
															$emit('close')
														">
														<button-component>
															<PlusIcon
																class="w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" />
															<span>Add New</span>
														</button-component>
													</a>
												</div>
											</div>
											<div class="px-4 max-h-[calc(100vh-140px)] overflow-auto">
												<div
													v-if="!hasContent"
													class="flex border border-gray-200 rounded-2xl items-center p-4 h-[calc(100vh-140px)] justify-center">
													<p class="text-center text-xs italic">No data yet</p>
												</div>
												<template v-if="hasContent">
													<div
														v-for="item in items.data"
														:key="item"
														class="border border-gray-200 rounded-2xl p-4 grid grid-cols-2 gap-2 pr-11 relative mb-4">
														<div class="col-span-1">
															<p class="font-bold text-sm mb-1">
																{{ item?.residence_type_meta?.description }} &nbsp;
															</p>
															<p class="text-xs font-medium text-neutral-500">
																Address Type
															</p>
														</div>
														<div class="col-span-1">
															<p class="font-bold text-sm mb-1">
																{{ item.province?.name }} &nbsp;
															</p>
															<p class="text-xs font-medium text-neutral-500">Province</p>
														</div>
														<div class="col-span-1">
															<p class="font-bold text-sm mb-1">{{ item.city?.name }} &nbsp;</p>
															<p class="text-xs font-medium text-neutral-500">
																City/Municipality/District
															</p>
														</div>
														<div class="col-span-1">
															<p class="font-bold text-sm mb-1">
																{{ item.barangay?.name }} &nbsp;
															</p>
															<p class="text-xs font-medium text-neutral-500">Barangay</p>
														</div>
														<div class="col-span-1">
															<p class="font-bold text-sm mb-1">
																{{ item.region?.name }} &nbsp;
															</p>
															<p class="text-xs font-medium text-neutral-500">Region</p>
														</div>
														<div class="col-span-1">
															<p class="font-bold text-sm mb-1">
																{{ item.address }} &nbsp;
															</p>
															<p class="text-xs font-medium text-neutral-500">Address</p>
														</div>
														<div class="col-span-2">
															<p class="font-bold text-sm mb-1">
																{{ item.direction }} &nbsp;
															</p>
															<p class="text-xs font-medium text-neutral-500">
																Direction
															</p>
														</div>
														<div class="absolute top-4 right-4">
															<Menu>
																<MenuButton>
																	<!-- <img
																		src="/assets/icon/ic-three-dots.svg"
																		alt="menu_icon"
																		class="w-5 h-5 object-contain cursor-pointer" /> -->
																	<three-dots-icon class="object-contain w-5 h-5 cursor-pointer" />
																</MenuButton>
																<transition
																	enter-active-class="transition ease-out duration-100"
																	enter-from-class="transform opacity-0 scale-95"
																	enter-to-class="transform opacity-100 scale-100"
																	leave-active-class="transition ease-in duration-75"
																	leave-from-class="transform opacity-100 scale-100"
																	leave-to-class="transform opacity-0 scale-95">
																	<MenuItems
																		class="absolute right-0 z-10 mt-2 min-w-[180px] origin-top-right rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
																		<div class="p-4">
																			<MenuItem>
																				<a
																					@click="
																						router.push(
																							`/patient/${patientId}/cases/${caseId}/patient-addresses/${item.id}/edit`
																						);
																						$emit('close')
																					"
																					class="cursor-pointer text-sm flex items-center mb-2">
																					<!-- <img
																						src="/assets/icon/ic-pencil.svg"
																						alt="pencil_icon"
																						class="w-6 h-6 object-contain mr-1.5 invert" /> -->
																					<pencil-icon class="w-6 h-6 object-contain mr-1.5 invert" />
																					Edit
																				</a>
																			</MenuItem>
																			<MenuItem>
																				<p
																					class="cursor-pointer text-sm flex items-center"
																					@click="removeConfirmation(item)">
																					<TrashIcon class="w-6 h-6 mr-1.5" />
																					Remove
																				</p>
																			</MenuItem>
																		</div>
																	</MenuItems>
																</transition>
															</Menu>
														</div>
													</div>
												</template>
												<slot></slot>
											</div>
										</div>
									</div>
								</DialogPanel>
							</TransitionChild>
						</div>
					</div>
				</div>
			</Dialog>
		</TransitionRoot>
		<confirmation-modal
			:typeTwo="true"
			:show="showConfirmation"
			@cancel="showConfirmation = false"
			@confirm="deleteItem()"
			cancel-text="Cancel"
			action-text="Confirm"
			title="Delete Record?"
			content="Are you sure you wish to delete this record?" />
		<success-modal
			:show="showSuccess"
			@confirm="redirectSuccess()"
			action-text="Close"
			title="Record Deleted!"
			:content="successMessage" />
	</div>
 </template>
 <script setup lang="ts">
 import { ref, onMounted, watch, computed } from "vue";
 import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
 import {
	Dialog,
	DialogPanel,
	TransitionChild,
	TransitionRoot,
	Menu,
	MenuButton,
	MenuItems,
	MenuItem,
 } from "@headlessui/vue";
 import { PlusIcon, XMarkIcon } from "@heroicons/vue/24/outline";
 import { TrashIcon } from "@heroicons/vue/24/solid";
 import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
 import SuccessModal from "@/components/modals/SuccessModal.vue";
 import PatientAddressService from "@/classes/Cases/PatientAddressService"; //TODO will remove
 import { PatientAddressIndex } from "@/interfaces/Cases/PatientAddress";// TODO will remove
 import { useRouter, useRoute } from "vue-router";
 import pickBy from "lodash/pickBy";
 import { useRecordStatusChecker } from "@/store/recordStatusChecker";
 import { useDraftLogger } from "@/store/draftlogger"
 import Relationships from "@/classes/Forms/Relationships";
 import ThreeDotsIcon from "@/components/icons/threeDotsIcon.vue";
 import PencilIcon from "@/components/icons/pencilIcon.vue";
 
 
 /******************************* For Offline Imports ************************************ */
 import CasePatientAddressService from "@/classes/Cases/CasePatientAddress/CasePatientAddressService";
 import { useNetworkStore } from "@/store/network";
 import CasePatientAddressForm from "@/classes/Cases/CasePatientAddress/Offline/Formatters/CasePatientAddressForm";
 import CasePatientAddressOfflineProcessor from "@/classes/Cases/CasePatientAddress/Offline/Processor/OfflineProcessor";
 const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
 /*************************************************************************************** */
 
 
 const router = useRouter();
 const route = useRoute();
 
 
 const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
 });
 const showConfirmation = ref<boolean>(false);
 const showSuccess = ref<boolean>(false);
 const patientId = ref<number | null>(route.params.patient);
 const caseId = ref<number | null>(route.params.case);
 const items = ref<PatientAddressIndex[]>([]);
 const hasContent = ref<boolean>(false);
 const selectedItemId = ref<number | null>(null);
 const successMessage = ref<string>("Selected record has been successfully deleted!");
 const offlineParams = ref<string>(route.query.offline);
 const recordStatusChecker = useRecordStatusChecker();
 const isRecordCreated = computed(() => recordStatusChecker.isCreatedPatientAddress);
 const draft = useDraftLogger();
 const relationship = new Relationships();
 
 
 const removeConfirmation = (item) => {
	showConfirmation.value = true;
	selectedItemId.value = item.id;
 };
 
 
 const deleteItem = async () => {
	showConfirmation.value = false;
	const response = await CasePatientAddressService.delete(
		patientId.value,
		caseId.value,
		selectedItemId.value,
		pickBy({}),
		isNetworkAvailable.value
	);
	console.log(response);
	if (response?.status === 200 || response?.data != undefined) {
        if (isNetworkAvailable.value) {
            await CasePatientAddressOfflineProcessor.delete(selectedItemId.value, caseId.value, true);
        }
		showSuccess.value = true;
		recordStatusChecker.isDeleted = true;
		draft.hasDraft = true;
	} else {
		console.log(response)
	}
 };
 
 
 const redirectSuccess = (): void => {
	showSuccess.value = false;
	draft.hasDraft = false;
	showConfirmation.value = false;
 };
 
 
 const getData = async () => {
	if (caseId.value) {
		const response = await CasePatientAddressService.index(
			patientId.value,
			caseId.value,
			pickBy({ rows: 10 }),
			isNetworkAvailable.value
		);
 
 
		if (response?.status === 200 || response?.data != undefined) {
			items.value = response.data.items;
			hasContent.value = response.data.items.total > 0 ? true : false;
 
 
			if(!isNetworkAvailable.value){
				await retrieveGuardianOffline(response);
			}

            if (isNetworkAvailable.value) {
                for (const item of items.value.data) {
                    await CasePatientAddressOfflineProcessor.syncToOffline(caseId.value, item);
                }
            }
		}
	}
 };
  /**
 * Retrieve resource data
 */
 const retrieveGuardianOffline = async (response: object):any => { 
	hasContent.value = response.data.items.total > 0 ? true : false; 
	response.data.items = await Promise.all(response.data.items.data?.map(async (item: any) => {
        return  await CasePatientAddressForm.viewForm(item);
    }));
	console.log(response.data.items);
	items.value = { data: response.data.items };    
	console.log(items.value);
};
 
 
 
 watch(
	() => isRecordCreated.value,
	(val) => {
		if (val) {
			getData();
		}
	}
 );
 
 
 watch(
	() => props.show,
	(val) => {
		if (val) {
			recordStatusChecker.isDeleted = false;
			getData();
		}
	}
 );
 </script>